var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 18 26 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "blue",
    className: "svg-path1",
    d: "M25.083 20.83c-2.106 0-3.829 1.722-3.829 3.829 0 2.106 1.723 3.829 3.83 3.829 2.105 0 3.829-1.723 3.829-3.83 0-2.106-1.724-3.829-3.83-3.829zm0 2.233c-.893 0-1.595.702-1.595 1.596h-.638c0-1.245.989-2.234 2.233-2.234v.638z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    className: "svg-path2",
    d: "M25.083 17c-5.201 0-10.051 2.808-12.668 7.34l-.192.319.192.319c2.617 4.53 7.467 7.34 12.668 7.34 5.202 0 10.052-2.81 12.669-7.34l.191-.32-.191-.319C35.135 19.81 30.285 17 25.083 17zm-11.392 7.659c1.692-2.777 4.34-4.787 7.372-5.744-1.82 1.276-3 3.35-3 5.744 0 2.393 1.18 4.467 3 5.743-3.032-.957-5.649-2.967-7.372-5.743zm5.648 0c0-3.16 2.585-5.744 5.744-5.744 3.16 0 5.744 2.584 5.744 5.744 0 3.159-2.585 5.743-5.744 5.743s-5.744-2.584-5.744-5.743zm9.765 5.743c1.819-1.276 3-3.382 3-5.743 0-2.394-1.181-4.468-3-5.744 3.032.957 5.648 2.967 7.371 5.744-1.723 2.776-4.34 4.786-7.37 5.743z",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureEntry);
export default __webpack_public_path__ + "static/media/secure-entry.e526fbfd470ed7d7d246f5fd8466b7fd.svg";
export { ForwardRef as ReactComponent };